import { createSlice } from "@reduxjs/toolkit";
import * as UserThunk from "./userThunk";

const initialState = {
  userProfile: {},
  branchdata: {},
};

const userSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: {
    [UserThunk.login.fulfilled]: (state, action) => {
      state.userProfile = action.payload;
    },
    [UserThunk.logout.fulfilled]: (state, action) => {
      state.userProfile = {};
    },

    [UserThunk.logindetails.fulfilled]: (state, action) => {
      state.userProfile = action.payload.response;
    },

    [UserThunk.loginDetailsByAdmin.fulfilled]: (state, action) => {
      state.userProfile = action.payload.response;
    },

    [UserThunk.getbranchdetailsbyuserid.fulfilled]: (state, action) => {
      state.branchdata = action.payload.response;
    },

    [UserThunk.updateGlobalSearch.fulfilled]: (state, action) => {
      state.globalSearchString = action.payload;
    },

    [UserThunk.getSubscriptionStatus.fulfilled]: (state, action) => {
      state.subScriptionStatus = action.payload.response;
    },
  },
});

export default userSlice.reducer;
